// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brarista-chat-container {
  --default-fs: 12px;
  --small-fs: 11px;

  all: revert;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: var(--default-fs);
  line-height: 1.5;
  color: #333;
}

.brarista-chat-container * {
  /* font-family: inherit !important; */
  box-sizing: border-box;
}

.brarista-chat-container body {
  min-height: 100vh;
  min-height: -webkit-fill-available;
}

.brarista-chat-container html {
  height: -webkit-fill-available;
}

.brarista-chat-container :is(p, select, button, input) {
    font-size: var(--default-fs);
}
  
.brarista-chat-container .small-text {
    font-size: var(--small-fs);
}

.brarista-chat-container button {
    cursor: pointer;
}

.brarista-chat-container input::placeholder {
    font-size: var(--default-fs);
    line-height: 'normal';
}

/* Scrollbar styling (no changes needed here) */
.brarista-chat-container ::-webkit-scrollbar {
  width: 5px;
}

.brarista-chat-container ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.brarista-chat-container ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

.brarista-chat-container ::-webkit-scrollbar-thumb:hover {
  background: #7d7d7d;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,WAAW;EACX;;2BAEyB;EACzB,mCAAmC;EACnC,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".brarista-chat-container {\n  --default-fs: 12px;\n  --small-fs: 11px;\n\n  all: revert;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n      sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: var(--default-fs);\n  line-height: 1.5;\n  color: #333;\n}\n\n.brarista-chat-container * {\n  /* font-family: inherit !important; */\n  box-sizing: border-box;\n}\n\n.brarista-chat-container body {\n  min-height: 100vh;\n  min-height: -webkit-fill-available;\n}\n\n.brarista-chat-container html {\n  height: -webkit-fill-available;\n}\n\n.brarista-chat-container :is(p, select, button, input) {\n    font-size: var(--default-fs);\n}\n  \n.brarista-chat-container .small-text {\n    font-size: var(--small-fs);\n}\n\n.brarista-chat-container button {\n    cursor: pointer;\n}\n\n.brarista-chat-container input::placeholder {\n    font-size: var(--default-fs);\n    line-height: 'normal';\n}\n\n/* Scrollbar styling (no changes needed here) */\n.brarista-chat-container ::-webkit-scrollbar {\n  width: 5px;\n}\n\n.brarista-chat-container ::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.brarista-chat-container ::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 5px;\n}\n\n.brarista-chat-container ::-webkit-scrollbar-thumb:hover {\n  background: #7d7d7d;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
